var _style, _path, _g, _g2, _defs, _path2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoloTokenLogoHor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2826.7 673.8",
    style: {
      enableBackground: "new 0 0 2826.7 673.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000164500962378543318440000015899914792142936979_);}\n\t.st2{fill:url(#SVGID_00000013164543479443020890000007726354701391219897_);}\n\t.st3{fill:url(#SVGID_00000031176886919123675270000007342468955485993869_);}\n\t.st4{fill:url(#SVGID_00000053545948416042343210000002488315812684434103_);}\n\t.st5{fill:url(#SVGID_00000099640095102332238670000017028090753424059269_);}\n\t.st6{fill:url(#SVGID_00000062902811801743932970000006964678761901594524_);}\n\t.st7{fill:url(#SVGID_00000028324228113375766970000001563010109566056586_);}\n\t.st8{fill:url(#SVGID_00000011749677278717687170000000833932494266744961_);}\n\t.st9{fill:#FFFAE6;}\n\t.st10{fill:#001E42;}\n\t.st11{fill:#173F91;}\n\t.st12{clip-path:url(#SVGID_00000013895365741096903770000008619033304677716905_);}\n\t.st13{fill:#1C52BF;}\n\t.st14{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 37.1145,
    cy: 591.0112,
    r: 350.8844,
    gradientTransform: "matrix(1 0 0 -1 0 659.7061)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F48C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3227,
    style: {
      stopColor: "#0F48C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    style: {
      stopColor: "#0E47BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#093182"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M673.8,336.9c0,186.1-150.8,336.9-336.9,336.9S0,523,0,336.9S150.8,0,336.9,0S673.8,150.8,673.8,336.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180332589969957955730000015155420919550349993_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.8909,
    y1: 695.6714,
    x2: 336.8909,
    y2: 93.6622,
    gradientTransform: "matrix(1 0 0 -1 0 676.3625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#445175",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#0C3CA0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#28437B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03349B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180332589969957955730000015155420919550349993_)"
    },
    d: "M0,336.9c0,120.2,63,225.8,157.8,285.4 H516c94.8-59.6,157.8-165.1,157.8-285.4S610.8,111.1,516,51.5H157.8C63,111.1,0,216.6,0,336.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092426035180159944170000017801095310968324789_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.8909,
    y1: 257.9474,
    x2: 336.8909,
    y2: 866.3027,
    gradientTransform: "matrix(1 0 0 -1 0 676.3625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E4B87",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#0C3CA0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#28437B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#34559B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092426035180159944170000017801095310968324789_)"
    },
    d: "M0,336.9c0,85.8,32.1,164.1,84.9,223.5 h504.1c52.8-59.5,84.9-137.8,84.9-223.5s-32.1-164.1-84.9-223.5H84.9C32.1,172.8,0,251.1,0,336.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003792034168789195890000010550306269078414240_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.8909,
    y1: 329.2858,
    x2: 336.8909,
    y2: 134.7243,
    gradientTransform: "matrix(1 0 0 -1 0 676.3625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#253D6E",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#0A3285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#203561"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B4680"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003792034168789195890000010550306269078414240_)"
    },
    d: "M0,336.9c0,50.1,11,97.7,30.6,140.5h612.6 c19.6-42.8,30.6-90.3,30.6-140.5s-11-97.7-30.6-140.5H30.6C11,239.2,0,286.8,0,336.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023255708755458920750000004114401647065100956_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.8909,
    y1: 265.8741,
    x2: 336.8909,
    y2: 597.1827,
    gradientTransform: "matrix(1 0 0 -1 0 676.3625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3759A0",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#0E45BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#305194"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C63B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023255708755458920750000004114401647065100956_)"
    },
    d: "M0,336.9c0,29,3.7,57.2,10.6,84h652.6 c6.9-26.9,10.6-55,10.6-84c0-29-3.7-57.2-10.6-84H10.6C3.7,279.7,0,307.9,0,336.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000169533878492746396940000008740003892704835489_",
    cx: 211.5435,
    cy: 412.0045,
    r: 471.6267,
    gradientTransform: "matrix(1 0 0 -0.9951 0 658.092)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2F65D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2837,
    style: {
      stopColor: "#235BD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    style: {
      stopColor: "#194CBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#1349BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1248BA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169533878492746396940000008740003892704835489_)"
    },
    d: "M310.1,4.4C136.6,17.9,0,162.4,0,338.6 s136.6,320.6,310.1,334.2c173.6-13.6,310.1-158,310.1-334.2S483.7,17.9,310.1,4.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000004522002786412081890000002302078830934847113_",
    cx: 412.2034,
    cy: 325.0942,
    r: 295.0087,
    gradientTransform: "matrix(1.0944 0 0 -1.1379 -140.9671 707.7855)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFCF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    style: {
      stopColor: "#FFFCF8",
      stopOpacity: 0.05098
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.31
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004522002786412081890000002302078830934847113_)"
    },
    d: "M329.2,5.7c-12.7-1.7-25.5-1.7-38.2,0 C126.7,27.9,0,168.2,0,337.9s126.7,310,291.1,332.2c12.7,1.7,25.5,1.7,38.2,0c164.4-22.3,291.1-162.5,291.1-332.2 S493.6,27.9,329.2,5.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000103234717457561925020000005497121114731065755_",
    cx: 282.6733,
    cy: 355.1783,
    r: 425.8231,
    gradientTransform: "matrix(0.9342 0 0 -1.0316 66.6102 665.0924)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#01348F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3227,
    style: {
      stopColor: "#0F4AC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    style: {
      stopColor: "#01348F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01348F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103234717457561925020000005497121114731065755_)"
    },
    d: "M558.8,334.7C558.8,179.7,445,54,304.7,54 C164.3,54,50.5,179.7,50.5,334.7s113.8,280.7,254.2,280.7C445,615.3,558.8,489.7,558.8,334.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005255352905698966010000004689102077371390909_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.0363,
    y1: 267.4884,
    x2: -14.5172,
    y2: 608.632,
    gradientTransform: "matrix(1 0 0 -0.9901 0 655.0278)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#173F91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7547,
    style: {
      stopColor: "#1F5AD4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005255352905698966010000004689102077371390909_)"
    },
    d: "M377,65.7c-34.6-10-71.5-10-106.1,0 C154.7,99.3,69.5,207.8,69.5,336.4c0,131.2,88.5,241.4,208.3,272.6c30.2,7.9,62.2,7.9,92.3,0c113.8-22.9,208.3-133.4,208.3-272.6 C578.5,207.8,493.3,99.3,377,65.7z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M418,172.4c-57.2,1.6-103.1,52.8-103.1,111.6S360.4,393.4,418,395.7c57.2,0,103.1-52.8,103.1-111.6 S475.3,174,418,172.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M480.4,284.1c0-37.6-27.9-68-62.3-68c-34.4,0-62.3,30.5-62.3,68s27.9,68,62.3,68 C452.5,352.1,480.4,321.6,480.4,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M439.2,220.2c-6.8-2.4-12.7-4-19.6-1.6c-23,8.1-39.8,34.3-39.8,65.4c0,31.7,17.5,58.3,41.2,65.9 c6,1.9,13.4-0.7,19.3-2.6c19.5-8.9,40.1-31.6,40.1-63.3C480.4,253,462.2,228.3,439.2,220.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M339.9,433c-30.5,0-55.1,26.9-55.1,58.3s24.3,58.1,55.1,58.1c31.1-1,55.1-26.7,55.1-58.1S370.5,434,339.9,433 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M361.1,491.4c0-12.8-9.5-23.1-21.2-23.1c-11.7,0-21.2,10.3-21.2,23.1c0,12.8,9.5,23.1,21.2,23.1 C351.6,514.5,361.1,504.1,361.1,491.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M348.2,470.2c-1.9-0.8-2-1.2-3.8-0.4c-6.3,2.7-10.9,11.4-10.9,21.7c0,10.5,4.8,19.3,11.3,21.8 c1.6,0.6,3.9-1.1,5.5-1.8c4.6-2.8,10.8-9.6,10.8-20.1C361.1,481.1,354.5,472.9,348.2,470.2z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000009569415469596167570000009730383645936563840_",
    d: "M369.5,67.2c-34-10.3-70.4-10.3-104.4,0 c-115.7,39.1-191,135-198.3,278.9C60,481.1,154,594.8,271.9,627c29.7,8.1,61.2,8.1,90.9,0c117.9-32.2,205-145.7,205-280.9 C567.8,213.6,484,101.8,369.5,67.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146474397516747966360000005831177304974748032_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009569415469596167570000009730383645936563840_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000146474397516747966360000005831177304974748032_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M172.6,115.5c-30.5,0-55.1,26.9-55.1,58.3s24.3,58.1,55.1,58.1c31.1-1,55.1-26.7,55.1-58.1 S203.2,116.5,172.6,115.5z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M193.8,173.9c0-12.8-9.5-23.1-21.2-23.1c-11.7,0-21.2,10.3-21.2,23.1s9.5,23.1,21.2,23.1 C184.3,197,193.8,186.6,193.8,173.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.9,152.7c-1.9-0.8-2-1.2-3.8-0.4c-6.3,2.7-10.9,11.4-10.9,21.7c0,10.5,4.8,19.3,11.3,21.8 c1.6,0.6,3.9-1.1,5.5-1.8c4.6-2.8,10.8-9.6,10.8-20.1C193.8,163.5,187.2,155.4,180.9,152.7z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M180,429.4c-12.7,0-23.8,11.4-23.8,25s10.5,24.8,23.8,24.8c13.6,0,23.8-11.2,23.8-24.8S192.9,429.4,180,429.4 z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M259.8,249.6c-12.7,0-23.8,11.4-23.8,25s10.5,24.8,23.8,24.8c13.6,0,23.8-11.2,23.8-24.8 S272.6,249.6,259.8,249.6z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M467.7,462.5c-12.7,0-23.8,11.4-23.8,25s10.5,24.8,23.8,24.8c13.6,0,23.8-11.2,23.8-24.8 S480.6,462.5,467.7,462.5z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M929.2,572.3v-32.7c-89.4-2-131.6-40.6-145.7-71.9c-3.7-8.5-5.4-16.3-5.4-22.8c0-27.1,18-45.4,50.7-45.4 c23.4,0,38.3,11.8,49.6,31c8.5,14.4,22.8,24.8,50.7,26.5v-71.3l-35.5-7.3C816.4,362,773.3,327,773.3,260.8 c0-75.3,65.4-122.9,155.9-125.2v-34.1c0-8.2,3.9-12.4,11.3-12.4c7.3,0,11.3,4.2,11.3,12.4v34.4c78.9,4.2,125.7,38.6,139.8,77.5 c2.5,7,3.9,14.4,3.9,22c0,23.7-18.3,38.6-47.6,38.6c-22,0-38.1-9-52.2-29.3c-9.6-13.8-23.4-23.1-44-25.9v71l35.2,7.3 c81.8,17.2,121.8,49.3,121.8,113.9c0,74.4-60.9,123.5-157,128.3v33c0,8.2-3.9,12.4-11.3,12.4C933.1,584.7,929.2,580.5,929.2,572.3 z M929.2,284.7v-66.5c-31,1.7-47.1,13-47.1,31.6C882.1,267.8,897.9,277.1,929.2,284.7z M951.7,390.5v66.2 c29.6-2.5,48.8-13,48.8-32.4C1000.5,405.4,985.9,398.3,951.7,390.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1488.6,89.1c16.3,0,30.4,5.9,42.3,17.8c11.9,11.9,17.8,26,17.8,42.3v79.7c-1.9,56.4-19,101-51.4,133.9 c-32.4,32.9-65.4,54.2-98.9,64v98.6c0,16.8-5.9,30.9-17.8,42.3c-11.9,11.4-26,17.1-42.3,17.1c-16.8,0-30.9-5.7-42.3-17.1 c-11.4-11.4-17.1-25.5-17.1-42.3v-98.6c-33.6-9.8-66.5-31.1-98.9-64c-32.4-32.9-49.5-77.5-51.4-133.9v-79.7 c0-16.3,5.9-30.4,17.8-42.3c11.9-11.9,26-17.8,42.3-17.8c16.8,0,30.9,5.9,42.3,17.8c11.4,11.9,17.1,26,17.1,42.3v75.5 c0,24.7,8.8,46,26.6,64c17.7,17.9,39.1,26.9,64.3,26.9c24.7,0,45.9-9,63.6-26.9c17.7-17.9,26.6-39.3,26.6-64v-75.5 c0-16.3,5.7-30.4,17.1-42.3C1457.8,95,1471.9,89.1,1488.6,89.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1791.8,89.1c59.2,1.4,108.5,22,147.8,61.9c39.4,39.8,60,88,61.9,144.3v83.2c-1.9,56.4-22.5,104.5-61.9,144.3 c-39.4,39.8-88.9,60.5-148.5,61.9c-59.2-1.4-108.5-22-147.8-61.9c-39.4-39.8-60-88-61.9-144.3v-83.2 c1.9-56.4,22.5-104.5,61.9-144.3C1682.6,111.1,1732.1,90.5,1791.8,89.1z M1700.9,299.5v74.8c0,24.7,8.8,46,26.6,64 c17.7,17.9,39.1,26.9,64.3,26.9c24.7,0,45.9-9,63.6-26.9c17.7-17.9,26.6-39.3,26.6-64v-74.8c0-24.7-8.9-46-26.6-64 c-17.7-17.9-38.9-26.9-63.6-26.9c-25.2,0-46.6,9-64.3,26.9C1709.7,253.5,1700.9,274.8,1700.9,299.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2102.9,89.1c16.3,0,30.4,5.9,42.3,17.8c11.9,11.9,17.8,26,17.8,42.3v315.9h189.4c16.3,0,30.4,5.9,42.3,17.8 c11.9,11.9,17.8,26,17.8,42.3c0,16.8-5.9,30.9-17.8,42.3c-11.9,11.4-26,17.1-42.3,17.1h-249.5c-16.8,0-30.9-5.7-42.3-17.1 c-11.4-11.4-17.1-25.5-17.1-42.3V149.2c0-16.3,5.7-30.4,17.1-42.3C2072,95,2086.1,89.1,2102.9,89.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M2617,89.1c59.2,1.4,108.5,22,147.8,61.9c39.4,39.8,60,88,61.9,144.3v83.2c-1.9,56.4-22.5,104.5-61.9,144.3 c-39.4,39.8-88.9,60.5-148.5,61.9c-59.2-1.4-108.5-22-147.8-61.9c-39.4-39.8-60-88-61.9-144.3v-83.2 c1.9-56.4,22.5-104.5,61.9-144.3C2507.9,111.1,2557.4,90.5,2617,89.1z M2526.2,299.5v74.8c0,24.7,8.8,46,26.6,64 c17.7,17.9,39.1,26.9,64.3,26.9c24.7,0,45.9-9,63.6-26.9c17.7-17.9,26.6-39.3,26.6-64v-74.8c0-24.7-8.9-46-26.6-64 c-17.7-17.9-38.9-26.9-63.6-26.9c-25.2,0-46.6,9-64.3,26.9C2535,253.5,2526.2,274.8,2526.2,299.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoloTokenLogoHor);
export default __webpack_public_path__ + "static/media/yolo_token_logo_hor.5fbbea6bc0903a97637343190329ebbf.svg";
export { ForwardRef as ReactComponent };